import React, { Component } from 'react'
import { Alert, Container, Row, Col, Button, Card} from "shards-react";
import { Form } from 'react-bootstrap'
import { Redirect } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';

import { EnginesAPI } from '../../components/apis';


class NewEngine extends Component {

  constructor (props, context) {
    super(props, context)
    this.props = props;
    this.state = {
      loading: false,
      goToDatabases: false,
      apiErr: null,
      enabled: false,
      formValidated: true,
    }
    this.data = {
      enabled: true,
    }

    this.api = new EnginesAPI(auth.getAccessToken());
  }

  handleChange = (field, event) => {

    if (field === 'enabled') {
      this.setState({
        [field]: event.target.value === 'true'
      })
    } else {
      this.setState({
        [field]: event.target.value
      })
    }
  }


  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const self = this;

    if (form.checkValidity() === false) {
      this.setState({
        formValidated: false,
      })
      return;
    }

    this.setState({
      loading: true
    })


    const engine = {
        "name" : this.state.name,
        "version" : this.state.version,
        "driver" : this.state.driver,
        "reformatter" : this.state.reformatter,
        "provider" : this.state.provider,
        "database_urlformat": this.state.database_urlformat
    }

    this.api.create(engine).then(() => {
      self.setState({
       loading: false,
       goToDatabases: true
      })
    }).catch(err => {
      self.setState({
         apiErr: err,
         loading: false
      })
    });

  }

  goBack = () => {
    history.goBack();
  }

  render = () => {
    // if(auth.isAuthenticated()){
        if (this.state.loading) {
          return (
            <div>
              <Container fluid>
                <br/>
                <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
                </div>
              </Container>
            </div>
          )
        }

        if (this.state.goToDatabases){
            return <Redirect to='/engines' />
        }

        let error
        if (this.state.apiErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiErr.message}</Alert></Container>
        }

        return (
          <div>

            {error}

            <Container fluid>

              <Row noGutters className="page-header py-4">
                <PageTitle title={this.context.t('Engines')} subtitle={this.context.t('Add')} className="text-sm-left mb-3" />
              </Row>

              <Card small style={{ marginBottom: '20px'}}>
                <Form validate="true" onSubmit={e => this.handleSubmit(e)} style={{ padding: "10px"}}>
                    <Row>
                        <Col lg="6">
                            <Form.Group controlId='name'>
                              <Form.Label>{this.context.t('Name')}</Form.Label>
                              <Form.Control type='text' placeholder={this.context.t('Oracle/MS SQL Server/..')} value={this.state.name} onChange={e => {this.handleChange('name', e)}} required/>
                            </Form.Group>

                            <Form.Group controlId='version'>
                              <Form.Label>{this.context.t('Version')}</Form.Label>
                              <Form.Control type='text' placeholder={this.context.t('X.xx')} value={this.state.version} onChange={e => {this.handleChange('version', e)}} required/>
                            </Form.Group>

                            <Form.Group controlId='provider'>
                              <Form.Label>{this.context.t('Provider')}</Form.Label>
                              <Form.Control type='text' placeholder={this.context.t('Microsoft/Oracle/..')} value={this.state.business_id} onChange={e => {this.handleChange('provider', e)}} required/>
                            </Form.Group>
                        </Col>
                        <Col lg="6">
                            <Form.Group controlId='driver'>
                              <Form.Label>{this.context.t('Driver')}</Form.Label>
                              <Form.Control type='text' value={this.state.driver} inputRef={ref => {this.email = ref}} placeholder={this.context.t('com.co.drivername.jdbc.Name')}  onChange={e => {this.handleChange('driver', e)}} required/>
                            </Form.Group>

                            <Form.Group controlId='reformatter'>
                              <Form.Label>{this.context.t('Reformatter')}</Form.Label>
                              <Form.Control type='text' value={this.state.reformatter} inputRef={ref => {this.email = ref}} placeholder={this.context.t('ar.org.restengine.db.formatters.Name')}  onChange={e => {this.handleChange('reformatter', e)}} required/>
                            </Form.Group>
                            <Form.Group controlId='database_urlformat'>
                              <Form.Label>{this.context.t('URL Format')}</Form.Label>
                              <Form.Control type='text' value={this.state.database_urlformat} inputRef={ref => {this.email = ref}} placeholder={this.context.t('jdbc:sqlserver://database_host:database_port;databaseName=database_name')}  onChange={e => {this.handleChange('database_urlformat', e)}} required/>
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr/>

                    <Button theme="primary" outline className="mb-2 mr-1" type='submit'>{this.context.t('Save')}</Button>
                    &nbsp;
                    <Button theme="secondary" outline className="mb-2 mr-1" onClick={this.goBack}>{this.context.t('Cancel')}</Button>
                  </Form>
              </Card>

            </Container>
          </div>
        )
    // }else{
    //     return <Redirect to='/' />
    // }
  }
}

NewEngine.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(NewEngine)
